import { render, staticRenderFns } from "./ResidentsFeedbackList.vue?vue&type=template&id=5f221a97&scoped=true&"
import script from "./ResidentsFeedbackList.vue?vue&type=script&lang=js&"
export * from "./ResidentsFeedbackList.vue?vue&type=script&lang=js&"
import style0 from "./ResidentsFeedbackList.vue?vue&type=style&index=0&id=5f221a97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f221a97",
  null
  
)

export default component.exports